// frontend/src/components/account/PaymentMethodPanel.jsx
import { Form, Input, Button, Typography } from "antd";

const { Text } = Typography;

const PaymentMethodPanel = ({
  paymentForm,
  profile,
  isStripeInitialized,
  activePanels,
  isUpdatePaymentMethodLoading,
  stripe,
  cardElement,
  handlePaymentMethodUpdate,
}) => {
  const status = (profile?.subscriptionStatus || "").toLowerCase();
  const canUpdateCard = [
    "active",
    "trial",
    "trialing",
    "past_due",
    "unpaid",
  ].includes(status);
  const isPastDue = status === "past_due" || status === "unpaid";

  return (
    <div style={{ padding: "16px 0" }}>
      {canUpdateCard ? (
        <Form
          form={paymentForm}
          layout="vertical"
          onFinish={handlePaymentMethodUpdate}
          style={{ maxWidth: "400px" }}
        >
          {isPastDue && (
            <Text
              style={{ display: "block", marginBottom: 12, color: "#666" }}
            >
              Update your card to retry the missed payment on your{" "}
              <strong>existing</strong> subscription. Prefer this over
              Resubscribe when possible — Resubscribe starts a new plan.
            </Text>
          )}
          <Form.Item
            name="cardholderName"
            label="Cardholder Name"
            rules={[{ required: true, message: "Please enter cardholder name" }]}
          >
            <Input placeholder="John Doe" style={{ borderRadius: "6px" }} />
          </Form.Item>
          <Form.Item label="Card Information">
            <div
              id="card-element"
              style={{
                padding: "10px",
                border: "1px solid #d9d9d9",
                borderRadius: "6px",
                backgroundColor: "white",
                minHeight: "40px",
              }}
            />
            {!isStripeInitialized && activePanels.includes("payment") && (
              <div style={{ color: "#999", fontSize: "14px", marginTop: "8px" }}>
                Loading payment form...
              </div>
            )}
          </Form.Item>
          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              loading={isUpdatePaymentMethodLoading}
              style={{
                borderRadius: "6px",
                backgroundColor: "#6DB33F",
                borderColor: "#6DB33F",
              }}
              disabled={!stripe || !cardElement}
            >
              {isPastDue
                ? "Update card & pay outstanding"
                : "Update Payment Method"}
            </Button>
          </Form.Item>
        </Form>
      ) : (
        <Text>
          {profile?.subscriptionCancelAtPeriodEnd
            ? "Your subscription is scheduled to end. Update card after you keep or renew your plan."
            : "Your subscription is inactive. Resubscribe from Manage membership to update your card."}
        </Text>
      )}
    </div>
  );
};

export default PaymentMethodPanel;